

















import { Vue, Component, Prop } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IInvoice } from "@/models/invoices";

@Component
export default class DownloadInvoiceCta extends Vue {
  // Props
  @Prop({ required: true })
  public invoice!: IInvoice;
  // Data
  public isProcessing = false;
  // Getters
  public get isVisible() {
    return !this.$_.isEmpty(this.invoice);
  }
  // Methods
  public async tryDownload() {
    if (this.isProcessing) return;
    this.isProcessing = true;
    await this.$store.dispatch(
      `data/${DataModules.INVOICES_PDFS}/tryDownload`,
      this.invoice
    );
    this.isProcessing = false;
  }
}
